@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
  <div class="apply-form-main bg-light" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
    <form name="loanForm" id="loan-form-request" #f="ngForm" (ngSubmit)="onSubmit(f)">
      <div class="loan-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="mb-4">
          <h5>User Loan Form</h5>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input type="number" class="form-control no-spin-arrows pl-3" name="loanAmountValue"
                [(ngModel)]="loanAmountValue" placeholder="Enter Loan Amount*" #loanAmount="ngModel" required />
                @if (!loanAmountValue && loanAmountValue !== null) {
                  <div class="warning">
                    Loan Amount must be greater than or equal to 0.
                  </div>
                }
                @if (loanAmount.touched && loanAmount.invalid) {
                  <div class="warning">
                    Loan Amount is required.
                  </div>
                }
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <input type="text" name="loanDate" id="loanDate" class="form-control no-spin-arrows pl-3" ngModel
                  placeholder="Enter Date of Apply - mm/dd/yyyy*" onfocus="(this.type='date')"
                  onblur="(this.type= this.value ? 'date' : 'text')" #loanDate="ngModel" required />
                  @if (loanDate.touched && loanDate.invalid) {
                    <div class="warning">
                      Loan Apply Date is required.
                    </div>
                  }
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="title-duration">
                    <p>Select Duration</p>
                  </label>

                  <ul class="nav">
                    @for (duration of durations; track duration) {
                      <li class="nav-item">
                        <div class="nav-link" [class.selected-duration]="duration === selectedDuration"
                          (click)="selectDuration(duration)">
                          {{ duration }}
                        </div>
                      </li>
                    }
                  </ul>
                </div>
                @if (installmentAmount.touched && installmentAmount.invalid) {
                  <div class="warning">
                    Duration is required.
                  </div>
                }
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Installment</label>
                  <input type="number" name="installmentAmount" [ngModel]="calculatedInstallmentAmount"
                    class="form-control no-spin-arrows pl-3" readonly #installmentAmount="ngModel" required />
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group">
                    <textarea class="form-control pl-4" id="loanPurpose" rows="3" name="loanPurpose" ngModel
                    #loanPurpose="ngModel" required [(ngModel)]="reason" (input)="trimText()"></textarea>
                    @if (
                      loanPurpose.valid &&
                      (loanPurpose.dirty || loanPurpose.touched)
                      ) {
                      <div>
                        @if (reason.trim().length < 150) {
                          <p class="alert alert-warning mt-2">
                            Ensure that the entered <strong>Loan Purpose</strong> contains
                            a minimum of 150 characters.
                          </p>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group upload-file">
                    <!-- Display the selected image if available -->
                    @if (selectedImage) {
                      <div class="selected-image mr-2">
                        <img [src]="selectedImage ? selectedImage : imagePath" alt="Selected Image" />
                      </div>
                    }

                    <div class="upfile btn btn-md">
                      Upload File
                      <div class="file">
                        <input type="file" name="profile_image" accept="image/*" id="profile_image" accept="image/*"
                          class="file btnPointer" (change)="onFileChange($event)" #profile_image_input />
                          <input type="hidden" name="loan_file" [(ngModel)]="imagePath" id="loanfile" />
                        </div>
                      </div>
                      @if (profileImageInvalid) {
                        <div class="warning-media mt-1 ml-2">
                          Image Size exceeds limit (max 1025 KB).
                        </div>
                      }
                      @if (selectedFileName) {
                        <div class="warning-media ml-2">
                          Selected File: {{ selectedFileName }}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <!--End 1st Section Personal Information -->
            </form>
          </div>
        </main>

        <!-- button footers start -->
        <div class="footer-button" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <div class="btn-float-right">
            <button (click)="goBack()" class="btn btn-light">Cancel</button>

            <button type="submit" class="btn btn-primary btnPointer ml-2" form="loan-form-request"
              [disabled]="f.invalid || (reason?.trim()?.length || 0) < 150">
              Submit
            </button>
          </div>
        </div>

        <!-- button footers end -->